import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import React, {
	forwardRef,
	useEffect,
	useImperativeHandle,
	useRef,
} from 'react'
import { useController } from 'react-hook-form'

const HFTextInput = forwardRef((props, ref) => {
	const { name, type, ignoreCustomValidity, ...attributes } = props
	const { field, fieldState } = useController({ name })

	const inputRef = useRef(null)

	useEffect(() => {
		if (!ignoreCustomValidity) {
			inputRef.current?.setCustomValidity?.(
				fieldState.error?.message ?? ''
			)
		}
	}, [fieldState.error?.message, ignoreCustomValidity, inputRef])

	useImperativeHandle(
		ref,
		() => {
			return {
				focus() {
					inputRef.current.focus()
				},
			}
		},
		[]
	)

	return (
		<TextInput
			{...attributes}
			{...field}
			ref={inputRef}
			value={
				typeof field.value === 'string' ||
				typeof field.value === 'number'
					? field.value
					: ''
			}
			type={type}
			onChange={(e) => {
				const inputValue =
					type === 'number'
						? e.target.valueAsNumber ?? e.target.value
						: e.target.value
				field.onChange(inputValue)
			}}
		/>
	)
})

export default HFTextInput
